import React, { useState } from 'react';

import clsx from 'clsx';

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import BobMenuItem from '../../../components/BobMenuItem';
import BobRadioButton from '../../../components/BobRadioButton';

import * as classes from './AddAttributeInsert.module.css';

const AddAttributeInsert = ({
    ...props
}) => {

    const [dataType, setDataType] = useState(null);

    return (
        <div className={classes.AddAttributeContainer}>
            <FormControl variant="outlined" size="small" className={classes.DataTypeInputWrapper}>
                <InputLabel>
                    Data Type
                </InputLabel>
                <Select
                    value={dataType}
                    id="dataType"
                    onChange={(event) => setDataType(event.target.value)}
                    name="Data Type"
                >
                    <BobMenuItem
                        className={classes.MenuItem}
                        key={0}
                        value={0}
                    >
                        String
                    </BobMenuItem>
                    <BobMenuItem
                        className={classes.MenuItem}
                        key={1}
                        value={1}
                    >
                        Integer
                    </BobMenuItem>
                    <BobMenuItem
                        className={classes.MenuItem}
                        key={2}
                        value={2}
                    >
                        Boolean
                    </BobMenuItem>
                </Select>
            </FormControl>
            <FormControl variant="outlined" size="small" className={classes.LengthInputWrapper}>
                <TextField
                    id="outlined-basic"
                    label="Length"
                    size="small"
                    variant="outlined"
                />
            </FormControl>
            <div className={classes.RadioGrid}>
                <div className={classes.RadioRow}>
                    <span style={{ paddingRight: '7rem' }} className={classes.RadioLabel}>
                        Required
                    </span>
                    <FormControl>
                        <RadioGroup
                            row
                            name="row-radio-buttons-group"
                        >
                            <FormControlLabel
                                className={classes.FormLabel}
                                value="Yes"
                                control={<BobRadioButton />}
                                label="Yes"
                            />
                            <FormControlLabel
                                className={classes.FormLabel}
                                value="No"
                                control={<BobRadioButton />}
                                label="No"
                            />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div className={classes.RadioRow}>
                    <span style={{paddingRight: '7.6rem'}} className={classes.RadioLabel}>
                        Editable
                    </span>
                    <FormControl>
                        <RadioGroup
                            row
                            name="row-radio-buttons-group"
                        >
                            <FormControlLabel
                                className={classes.FormLabel}
                                value="Yes"
                                control={<BobRadioButton size="large" />}
                                label="Yes"
                            />
                            <FormControlLabel
                                className={classes.FormLabel}
                                value="No"
                                control={<BobRadioButton size="medium" />}
                                label="No"
                            />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div className={classes.RadioRow}>
                    <span style={{ paddingRight: '8.5rem' }} className={classes.RadioLabel}>
                        Visible
                    </span>
                    <FormControl>
                        <RadioGroup
                            row
                            name="row-radio-buttons-group"
                        >
                            <FormControlLabel
                                className={classes.FormLabel}
                                value="Yes"
                                control={<BobRadioButton />}
                                label="Yes"
                            />
                            <FormControlLabel
                                className={classes.FormLabel}
                                value="No"
                                control={<BobRadioButton />}
                                label="No"
                            />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div className={classes.RadioRow}>
                    <span className={classes.RadioLabel}>
                        Allow for Multiple
                    </span>
                    <FormControl>
                        <RadioGroup
                            row
                            name="row-radio-buttons-group"
                        >
                            <FormControlLabel
                                className={classes.FormLabel}
                                value="Yes"
                                control={<BobRadioButton />}
                                label="Yes"
                            />
                            <FormControlLabel
                                className={classes.FormLabel}
                                value="No"
                                control={<BobRadioButton />}
                                label="No"
                            />
                        </RadioGroup>
                    </FormControl>
                </div>
            </div>
            <div className={classes.SaveContainer}>
                <span className={classes.SaveLabel}>Save the new attribute</span>
                <span className={clsx('material-icons-outlined', classes.SaveIcon)}>
                    done
                </span>
                <span className={clsx('material-icons-outlined', classes.SaveIcon)}>
                    close
                </span>
            </div>
        </div>
    );
};

export default AddAttributeInsert;
